





















































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
// @ts-ignore
import store from "../store";
// @ts-ignore
import Tools from "../helpers/Tools";
import ErrorHandler from "../helpers/ErrorHandler";
import {Player} from "../../types";
import EventApi from "../api/EventsApi";

@Component({})

export default class GameTaskForm extends Vue {
    @Prop({required: true}) private readonly taskType!: string;
    @Prop({required: true}) private readonly playerId!: string;
    @Prop({required: true}) private readonly players!: Array<Player>;
    @Prop({required: true})
    private sendTaskMethod!: (form: HTMLFormElement,
                              visibleFor: Array<string>,
                              successCallback: (data: any) => void,
                              errorCallback: (data: any) => void) => void;
    private hasInputValue: boolean = false;
    private emptyFields: boolean = false;
    private videoId: string = '';
    private imgPreview: string = '';
    private formErrors: any = null;
    private visibility: any = null;
    private visibleFor: Array<string> = [];
    private videoLink: string = '';
    private imageLink: string = '';

    mounted(): void
    {
        this.toggleNewTaskVisibilityAll();
    }

    /**
     * Очистить инпут ссылки на видео
     */
    private clearVideoLink(): void
    {
        this.videoLink = '';
    }

    /**
     * Очистить инпут ссылки на картинку
     */
    private clearImageLink(): void
    {
        this.imageLink = '';
    }

    /**
     * Удалить загруженное изображение
     */
    private deleteImg(): void
    {
        this.clearImageLink();
        this.imgPreview = '';
    }

    /**
     * Установка файлов извне
     */
    private setFiles(files: FileList): void
    {
        console.log(files);
        if (this.imgPreview) {
            return;
        }

        const form = this.$refs.taskForm as HTMLFormElement;
        (form.elements as any).file.files = files;
        this.getFilePreview((form.elements as any).file);
        this.hasInputValue = !!this.imgPreview;
    }

    /**
     * Получить превью файлов
     */
    private getFilePreview(input: HTMLInputElement) {
        this.imgPreview = '';
        if (input.files && input.files[0]) {
            this.imgPreview = URL.createObjectURL(input.files[0]);
        } else if (input.type === 'text') {
            this.imgPreview = input.value;
        }
    }

    /**
     * Обработка изменений в полях формы
     */
    onInput(e: any) {
        const form = this.$refs.taskForm as HTMLFormElement;
        const input = form.elements as HTMLFormControlsCollection;

        switch (this.taskType) {
            case 'video':
                (input as any).text.value = '';
                (input as any).file.value = '';
                (input as any).imageUrl.value = '';

                this.imgPreview = '';
                this.videoId = Tools.getYouTubeVideoId(e.target.value);
                this.hasInputValue = !!this.videoId;
                break;
            case 'image':
                (input as any).text.value = '';
                (input as any).video.value = '';
                this.videoId = '';
                this.getFilePreview(e.target);
                this.hasInputValue = !!this.imgPreview || (input as any).imageUrl.value;
                break;
            case 'text':
                (input as any).video.value = '';
                (input as any).file.value = '';
                (input as any).imageUrl.value = '';

                this.videoId = '';
                this.imgPreview = '';
                this.hasInputValue = !!e.target.value;
                break;
        }

    }

    /**
     * Название задания
     */
    private getTaskName(): string
    {
        if (typeof store.getters.getGameState.tasks !== 'undefined') {
            return store.getters.getGameState.tasks.main.is_filled ? 'additional' : 'main';
        }

        return '';
    }

    /**
     * Отправка формы
     */
    sendTask(e: Event)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        this.emptyFields = false;
        if (!this.hasInputValue) {
            this.emptyFields = true;
            return;
        }
        const form = this.$refs.taskForm as HTMLFormElement;

        this.sendTaskMethod(form, this.visibleFor, (data: any) => {
            form.reset();
            this.imgPreview = '';
            this.videoId = '';
            this.formErrors = null;
            for (let el of form.elements as any) {
                el.classList.remove('has-error');
            }
        }, (errorData: any) => {
            if (errorData.responseJSON && errorData.responseJSON.errors) {
                this.formErrors = errorData.responseJSON.errors;

                Object.keys(this.formErrors).forEach((el) => {
                    form.elements[el as any].classList.add('has-error');
                })
            } else {
                ErrorHandler.error('Ошибка запроса');
            }
        });
    }

    /**
     * Изменить видимость для всех ситов
     */
    private toggleNewTaskVisibilityAll() {

        if (this.visibleFor.length > 1) {
            this.visibleFor = [];
        } else {
            const players = this.players;
            this.visibleFor = players.map((el) => {
                return el.id;
            });
        }
    }

    /**
     * Изменить видимость для конкретных ситов
     * @param playerId - ID игрока
     */
    private toggleNewMessageVisibilityFor(playerId: string) {
        this.visibleFor = Tools.toggleArrayElement(this.visibleFor, playerId);
    }
    /**
     * Закрыть форму
     */
    private hideTaskForm(e: any) {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});
        const form = e.target.closest('form');
        form.reset();
        this.imgPreview = '';
        this.videoId = '';
        this.formErrors = null;
        for (let el of form.elements) {
            el.classList.remove('has-error');
        }
        this.$emit('hideTaskForm');
    }

    /**
     * Код цвета игрока
     */
    private getPlayerColorCode(): void
    {
        let player = (this.$parent as any).findPlayer(this.playerId);
        return player ? player.color.code : null;
    }

     /**
     * Код контрастного цвета игрока
     */
     private getPlayerContrastColorCode(): string
    {
        let player = (this.$parent as any).findPlayer(this.playerId);
        return player ? player.color.contrast : null;
    }

    private onImageLoad(e: any) {
        const target = e.target;
        this.$emit('imageLoad', {
            img: target,
            task: this.getTaskName(),
        });
    }

    /**
     * Дроп картинки в зону добавления задания
     * @param e
     * @private
     */
    private dropImage(e: any): void
    {
        e.preventDefault();
        if (this.taskType !== 'image') {
            return;
        }

        const input = this.$refs.imgInput as HTMLInputElement;
        const filesArray = Array.from(e.dataTransfer.files);

        if (typeof filesArray[0] === 'undefined') {
            return;
        }

        const dt = new DataTransfer();
        // @ts-ignore
        dt.items.add(filesArray[0]);
        input.files = dt.files;
        this.hasInputValue = true;
        this.getFilePreview(input);
    }

}
